import { render, staticRenderFns } from "./add-button.component.vue?vue&type=template&id=238874df&scoped=true&"
import script from "./add-button.component.vue?vue&type=script&lang=ts&"
export * from "./add-button.component.vue?vue&type=script&lang=ts&"
import style0 from "./add-button.component.vue?vue&type=style&index=0&id=238874df&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238874df",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
